import { forkJoin as observableForkJoin } from 'rxjs';

import {flatMap, switchMap} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { HttpRepository } from './http.repository';
import { GlobalConfig } from '../configs/GlobalConfig';
import { Observable } from 'rxjs';
import { Plant } from '../interfaces/rest/Plant';
import { MarketSector } from '../interfaces/rest/MarketSector';
import { Room } from '../interfaces/rest/Room';
import { Line } from '../interfaces/rest/Line';
import { HttpClient } from "@angular/common/http";
import {PagingRequest} from "../interfaces/rest/paging/PagingRequest";
import {PagedData} from "../interfaces/rest/paging/PagedData";

@Injectable()
export class PlantRepository {

    constructor(protected http: HttpClient,
                protected httpRepository: HttpRepository) {
    }



    /**
     * Get plants
     * @param {number} userId If specified, then only plants which are assigned to the user will be returned.
     * @param {boolean} expandLines
     * @param {boolean} expandAssets
     * @param {boolean} expandShifts
     * @returns {Observable<Array<Plant>>}
     */
    getPlantsByUser(userId = -1, expandLines = false, expandAssets = false, expandShifts = false): Observable<Array<Plant>> {
        let endpoint = GlobalConfig.endpoints.plants;
        endpoint += `?uid=${userId}`;
        endpoint += `&expandLines=${expandLines}`;
        endpoint += `&expandAssets=${expandAssets}`;
        endpoint += `&expandShifts=${expandShifts}`;

        return this.httpRepository.get(endpoint);
    }

    /**
     * Get plant by plant ID.
     * @param plantId
     * @returns {Observable<Plant>}
     */
    getPlant(plantId: number): Observable<Plant> {
        return this.httpRepository.get(`${GlobalConfig.endpoints.plants}/${plantId}`);
    }

    /**
     * Get plants by plant IDs.
     * @param plantIds
     * @returns {Observable<any[]>}
     */
    getPlantsByPlantIds(plantIds : Set<number>): Observable<Array<Plant>> {
        let observables: Array<Observable<Plant>> = [];
        plantIds.forEach((plantId: number) => {
            observables.push(this.getPlant(plantId));
        });

        return observableForkJoin(observables);
    }

    getPlantsWithPaging(pagingRequest: PagingRequest): Observable<PagedData> {
      return this.httpRepository.post(`${GlobalConfig.endpoints.plants}/paging`, pagingRequest);
    }

    /**
     * Get plants by client ID.
     * @param clientId
     * @param userId
     * @returns {Observable<Array<Plant>>}
     */
    getPlantsByClient(clientId: number | null | undefined, userId?: number | undefined | null): Observable<Array<Plant>> {
        let endpoint = `${GlobalConfig.endpoints.clients}/${clientId}/plants`;
        if (userId) {
            endpoint += `?userId=${userId}`;
        }
        return this.httpRepository.get(endpoint);
    }

    /**
     * Create a new plant.
     * @param {Plant} payload
     * @returns {Observable<any>}
     */
    addPlant(payload: Plant) {
        return this.httpRepository.post(GlobalConfig.endpoints.plants, payload);
    }

    /**
     * Update existing plant.
     * @param {Plant} payload
     * @param plantId
     * @returns {Observable<any>}
     */
    updatePlant(payload: Plant, plantId: number) {
        return this.httpRepository.put(`${GlobalConfig.endpoints.plants}/${plantId}`, payload);
    }

    /**
     * Get all market sectors.
     * @returns {Observable<any>}
     */
    getMarketSectors(): Observable<any> {
        return this.httpRepository.get(GlobalConfig.endpoints.marketSectors);
    }

    /**
     * Get Rooms for a specific plant.
     * @param {number} plantId
     * @returns {Observable<Array<Room>>}
     */
    getRoomsForPlant(plantId: number): Observable<Array<Room>> {
        return this.httpRepository.get(`${GlobalConfig.endpoints.plants}/${plantId}/rooms`);
    }
}
